import { render } from "./CustomerDateOfBirthView.vue.ts?vue&type=template&id=052b01f8&scoped=true&ts=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./CustomerDateOfBirthView.vue?vue&type=template&id=052b01f8&scoped=true&ts=true"
import script from "./CustomerDateOfBirthView.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./CustomerDateOfBirthView.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomerDateOfBirthView.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./CustomerDateOfBirthView.vue?vue&type=script&setup=true&lang=ts"

import "./CustomerDateOfBirthView.vue.scss?vue&type=style&index=0&id=052b01f8&scoped=true&lang=scss!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./CustomerDateOfBirthView.vue?vue&type=style&index=0&id=052b01f8&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-052b01f8"],['__file',"src/apps/merchant3/components/customer-registration/views/CustomerDateOfBirthView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "052b01f8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('052b01f8', __exports__)) {
    api.reload('052b01f8', __exports__)
  }
  
  module.hot.accept("./CustomerDateOfBirthView.vue.ts?vue&type=template&id=052b01f8&scoped=true&ts=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./CustomerDateOfBirthView.vue?vue&type=template&id=052b01f8&scoped=true&ts=true", () => {
    api.rerender('052b01f8', render)
  })

}


export default __exports__